module.exports = __webpack_public_path__ + "static/media/komme_nærare.1d3972b8.m4a";